import apiRequest from "../../utils/ApiRequest/apiRequest.js";
import Cookies from "universal-cookie";
import CookiesJS from "js-cookie";
import config from "config";
import addRefererToBodyRequest from "helpers/addRefererToBodyRequest.ts";
import isInIframe from "utils/detectIframe.ts";
import { updater } from "../../utils/updater.js";
import { get_browser } from "../../utils/gridHelpers.js";
import {
  removeLocalStorage,
  setLocalStorage,
} from "utils/globalLocalStorage.js";
import { ISRAEL_COUNTRY_NAME } from "utils/globalConsts.ts";
import { ReactGetFavoriteContactListApiRequest } from "../../api/ContactsListsController.ts";
import { CustomDomainPagesE, MainDomainPagesE } from "../../models/enums.ts";
import checkCurrDomainIsOrgDomain from "helpers/checkCurrDomainIsOrgDomain.ts";
import { MVCLoginApiRequest } from "api/UsersController.ts";
import formBodyString from "helpers/formBodyString.ts";

const cookies = new Cookies();

const REMEMBER_ME_EXPIRATION_DURATION = 30;

const isInviteByLinkPage = window.location.pathname.includes(
  CustomDomainPagesE.INVITE
);

// User API factory.
export function userFactory({ state, setState }) {
  const updateState = updater(setState);
  //getters
  const isTokenExist = !!cookies.get(config.api.jumbomailApiAuthCookie);

  const isLoggedIn = () => state.loggedIn && isTokenExist;
  // const isLoggedIn = () => state.loggedIn;

  const setIsPendingLogin = (value) =>
    updateState((draft) => {
      draft.isPendingLogin = value;
    });

  const getIsPendingLogin = () => state.isPendingLogin;

  const requestOriginURL = window.location.origin.includes("localhost")
    ? "localhost"
    : `.${window.location.hostname}`;

  const premiumExpired = () =>
    state.userData &&
    state.userData.userSubscriberSystemName === "premium" &&
    !state.userData.IsSubscribed;

  const isExpress = () =>
    state.userData &&
    state.userData.IsEmbedSubscribed &&
    state.userData.EmbedSubscription === "JM Embed Express"
      ? true
      : false;

  const isPremium = () =>
    state.userData &&
    state.userData.IsSubscribed &&
    state.userData.userSubscriberSystemName === "premium"
      ? true
      : false;

  const isPro = () =>
    state.userData &&
    state.userData.IsSubscribed &&
    state.userData.Subscription === "JM Pro"
      ? true
      : false;

  const isBusiness = () =>
    state.userData &&
    state.userData.IsSubscribed &&
    state.userData.Subscription === "JM Business"
      ? true
      : false;

  const isSubscribed = () => state.userData?.IsSubscribed;

  const getUserStatus = () =>
    isSubscribed()
      ? isBusiness()
        ? "business"
        : isPro()
        ? "pro"
        : "subscribed"
      : "anonymous";

  const getIsIsrael = () => state.isIsrael;

  const setIsIsrael = (isIsrael) => {
    updateState((draft) => {
      draft.isIsrael = isIsrael;
    });
  };

  const getUserData = () => state.userData;

  const isUserHasProfileImage = () =>
    !!(state.userData && state.userData.ProfileImageUrl);

  const setUserData = (data) => {
    if (data) {
      updateState((draft) => {
        draft.userData.UserFirstName = data.UserFirstName;
        draft.userData.UserLastName = data.UserLastName;
        draft.userData.UserName = data.UserName;
        draft.userData.UserPhone = data.UserPhone;
        draft.userData.UserBirthdate = data.UserBirthdate;
        draft.userData.UserOccupation = data.UserOccupation;
        draft.userData.UserCountry = data.UserCountry;
        draft.userData.UserGender = data.UserGender;
        draft.userData.UserAvailableSubUsersLicenses =
          data.UserAvailableSubUsersLicenses;
      });
    }
  };

  const setUserDataProp = ({ key, value }) => {
    updateState((draft) => {
      draft.userData[key] = value;
    });
  };
  const setUserBillingDetailsDataProp = ({ key, value }) => {
    updateState((draft) => {
      draft.userData.billingDetails[key] = value;
    });
  };

  const updateUserUsedStorage = (data) => {
    if (data) {
      updateState((draft) => {
        draft.userData.UserUsedStorage = data.UserUsedStorage;
      });
    }
  };

  const getUserProfileImage = () =>
    state.userData && state.userData.ProfileImageUrl;

  /**
   * Get the cookie from the server and keep it in local storage
   * @param {object} cookie
   */
  const setAuthCookieInLocalStorage = (cookie, isRememberMe) => {
    if (cookie.status === "success") {
      const auth = cookie.data;
      removeLocalStorage("Auth");
      setLocalStorage(
        "Auth",
        JSON.stringify({
          auth,
        })
      );

      const cookieOptions = {
        path: "/",
        domain: requestOriginURL,
      };

      if (isRememberMe) {
        const expirationDate = new Date();
        expirationDate.setDate(
          expirationDate.getDate() + REMEMBER_ME_EXPIRATION_DURATION
        );
        cookieOptions.expires = expirationDate;
        CookiesJS.set("auth_remember", expirationDate, cookieOptions);
      } else {
        const authExpirationDate = CookiesJS.get("auth_remember");
        if (authExpirationDate) {
          cookieOptions.expires = new Date(authExpirationDate);
        }
      }

      let tokenString = auth;

      if (typeof auth === "string" && auth.includes("access_token")) {
        tokenString = JSON.parse(auth).access_token;
      }
      if (typeof auth === "object") {
        tokenString = auth.access_token;
      }

      return true;
    }
    return false;
  };

  const handleResponse = (response) => {
    if (response?.status === "success") {
      const userBucketName = response.data.UserData.BucketName;

      if (userBucketName && window.location.origin !== userBucketName) {
        //redirect to the user's domain

        // if current page is page from MainDomainPagesE
        if (
          Object.values(MainDomainPagesE).some((page) =>
            window.location.pathname.includes(page)
          )
        ) {
          const currLang = window.location.pathname.split("/")[1];
          window.location.href = `${userBucketName}/${currLang}/home`;
          logout();
          return;
        }

        window.location.href = `${userBucketName}${window.location.pathname}`;
        logout();
        return;
      }

      setUser(response.data);

      return {
        message: response.data,
        status: response?.status,
      };
    } else {
      logout();
      return {
        message: response.data,
        status: response?.status,
      };
    }
  };

  const contactUs = async (body) => {
    const requestBody = {
      ContactEmail: body.ContactEmail,
      ContactSender: body.ContactSender, //name
      ContactPhone: body.ContactPhone,
      ContactTitle: body.ContactTitle, //dropdown
      ContactMessage: body.ContactMessage,
      ContactUserStatus: getUserStatus(),
      ContactDomain: "https://www.jumbomail.me/",
      ContactPage: "contact-us",
      ContactCulture: body.ContactCulture,
      Culture: body.Culture,
      MailType: body.MailType,
      RecaptchaResponse: body.recaptchaResponse,
      ContactBrowser: get_browser().name + " - " + get_browser().version,
      ContactIp: body.userIp,
      ContactPlatform: body.platform,
      // captchaServiceName: "cloudflare",
    };

    const response = await apiRequest(
      "ContactMessages",
      "SentContactMessage",
      requestBody,
      "POST"
    );
    if (response.status === "success") {
      return {
        message: response.data,
        status: response.status,
      };
    } else {
      return {
        message: response.data,
        status: response.status,
      };
    }
  };

  const signup = async (body) => {
    // passwrods dont match throw error before making request
    if (body.Password !== body.PasswordValidation) {
      return handleResponse({
        status: "error",
        data: "passwords-dont-match-message",
      });
    }

    addRefererToBodyRequest(body);

    if (checkCurrDomainIsOrgDomain()) {
      body.isInvitationPage = isInviteByLinkPage;

      body.inviteByEmailToken = window.location.pathname.includes(
        CustomDomainPagesE.SUB_USER_COMPLETE
      )
        ? window.location.pathname.split("/")[3]
        : null;
    }

    const response = await apiRequest(
      "Users",
      "ReactRegisterUser",
      body,
      "POST"
    );

    if (
      response.status === "success" &&
      response.data &&
      response.data.nowDate
    ) {
      cookies.set("loginDate", response.data.nowDate, {
        path: "/",
        domain: ".jumbomail.me",
      });
    }

    if (
      response.status === "error" &&
      response.data === "email-already-exist" &&
      window.location.href.includes("/invite/")
    ) {
      return {
        message: response.data + "-invitation-link",
        status: response.status,
      };
    } else {
      return handleResponse(response);
    }
  };

  const fetchIsraelUser = async () => {
    const response = await apiRequest("Users", "CheckIfIsraeliIp?userMail");
    if (response.status === "success") {
      if (response.data) {
        setIsIsrael(true);
      } else {
        setIsIsrael(false);
      }
    }
  };

  //authenticate after redirecting from old MVC
  const authenticateAfterMvc = async () => {
    if (isInIframe()) return;
    setIsPendingLogin(true);

    const reactAuth = {
      status: "success",
      token_type: "bearer",
      expires_in: 315359999,
      loginDate: cookies.get("loginDate"),
    };

    addRefererToBodyRequest(reactAuth);

    await setAuth(reactAuth);

    try {
      const res = await MVCLoginApiRequest(reactAuth);

      handleResponse(res);

      //handeling if user is from israel
      if (res.data.UserData?.UserCountry === ISRAEL_COUNTRY_NAME) {
        setIsIsrael(true);
      } else {
        await fetchIsraelUser();
      }
      setIsPendingLogin(false);
      return res;
    } catch (error) {
      setIsPendingLogin(false);
      return {
        status: "error",
      };
    }
  };

  const tokenLogin = async (formBody) => {
    const res = await apiRequest(
      "Token",
      null,
      formBody,
      "POST",
      "x-www-form-urlencoded"
    );
    if (res.status === "success") {
      cookies.set(config.api.jumbomailApiAuthCookie, res.data.access_token, {
        domain: config.api.jumbomailApiDomain,
        path: "/",
      });
      // replaced universal cookies, for some reason it wasnt able to set cookie with on test/prod
      // idk why, need to investigate more
      document.cookie =
        config.api.jumbomailApiAuthCookie +
        "=" +
        res.data.access_token +
        ";path=/";
    }
    return res;
  };

  const login = async (body) => {
    setIsPendingLogin(true);

    let res;

    // Get authentication token

    addRefererToBodyRequest(body);

    const loginDetails = {
      first: null,
      UserName: encodeURIComponent(body.UserName),
      Password: encodeURIComponent(body.Password),
      grant_type: "password",
      user_type: "simple_user",
      dummy: null,
      Code: body?.Code || "",
      SessionId: body?.SessionId || "",
      RecaptchaResponse: body.recaptchaResponse || body.RecaptchaResponse,
      captchaServiceName:
        body.captchaServiceName || localStorage.getItem("globalCaptchaType"),
      isInvitationPage: window.location.pathname.includes(
        CustomDomainPagesE.INVITE
      ),
      inviteByEmailToken: window.location.pathname.includes(
        CustomDomainPagesE.SUB_USER_COMPLETE
      )
        ? window.location.pathname.split("/")[3]
        : null,
    };

    const tokenPayload = formBodyString(loginDetails);

    res = await tokenLogin(tokenPayload);
    setAuth(res, body.Remember);

    const parsedRes =
      typeof res.data === "string" ? JSON.parse(res.data) : res.data;

    if (
      parsedRes?.error === "required-mfa-code" ||
      parsedRes?.error === "wrong-mfa-code"
    ) {
      res = {
        status: "error",
        message: parsedRes.error,
      };
      return res;
    }

    if (res.status === "error") {
      setIsPendingLogin(false);
      const invalid_grant = "error-login-invalid-credentials";
      const parsedData = JSON.parse(res.data);
      const error = parsedData?.error;
      const errorDescription = parsedData?.error_description;

      res = {
        status: "error",
        message: error === "invalid_grant" ? invalid_grant : error,
        errorDescription: errorDescription,
      };
    } else {
      const nowDate = await apiRequest("Utils", "ReactGetNowDate");

      // add password to the cookie of UploadPassword
      if (nowDate.data) {
        cookies.set("loginDate", nowDate.data, {
          path: "/",
          domain: requestOriginURL,
        });

        const payload = {
          status: "success",
          token_type: "bearer",
          expires_in: 315359999,
          loginDate: cookies.get("loginDate"),
        };

        const response = await apiRequest({
          controller: "Users",
          functionName: "MVCLogin",
          parameters: payload,
          method: "POST",
          contentType: "application/json",
        });

        res = handleResponse(response);

        if (response?.status === "error" && response?.data) {
          return {
            status: response?.status,
            message: response?.data,
          };
        }

        cookies.remove("logout_order", {
          path: "/",
          domain: ".jumbomail.me",
        });
        cookies.remove("logout_order", {
          path: "/",
          domain: ".www.jumbomail.me",
        });
      }

      const payload = {
        status: "success",
        token_type: "bearer",
        expires_in: 315359999,
        loginDate: cookies.get("loginDate"),
      };

      const response = await apiRequest({
        controller: "Users",
        functionName: "MVCLogin",
        parameters: payload,
        method: "POST",
        contentType: "application/json",
      });

      res = handleResponse(response);

      cookies.remove("logout_order", {
        path: "/",
        domain: requestOriginURL,
      });
      cookies.remove("logout_order", {
        path: "/",
        domain: requestOriginURL,
      });
      setIsPendingLogin(false);
      return res;
    }

    return res;
  };

  /**
   * logging out the user
   */
  const logout = async () => {
    const userName = getUserData().UserName;
    cookies.remove(config.api.jumbomailApiAuthCookie, {
      path: "/",
      domain: `.${window.location.hostname}`,
    });
    cookies.remove(config.api.jumbomailApiAuthCookie, {
      path: "/",
      domain: `.www.${window.location.hostname}`,
    });
    cookies.remove(config.api.jumbomailApiAuthCookie, {
      path: "/",
    });
    cookies.remove("auth_remember", {
      path: "/",
    });
    cookies.remove("email", {
      path: "/",
      domain: `.${window.location.hostname}`,
    });
    cookies.set("logout_order", "1", {
      path: "/",
      domain: `.${window.location.hostname}`,
    });
    window.dataLayer.push({
      user_id: 0,
      user_subscribe: false,
      user_subscription_type: "",
      event: "logout",
    });
    setUser(null);
    setAuth(null);
    // isIsrael logic
    fetchIsraelUser();
    // additional logout action for old page
    try {
      await apiRequest(
        "Users",
        "LogoutMVC",
        { userName },
        "POST",
        null,
        "application/json",
        null,
        false,
        true
      );

      document.cookie = "";
    } catch (error) {
      console.log(error);
    }
  };
  /**
   * get user data by user-mail
   * @param {String} username - the users' email
   */
  const getUserByMail = (email) => {
    const parameters = { UserName: email };
    const content = apiRequest("Users", "getUserByMail", parameters);
    setUser(content);
  };

  const fetchUserBillingDetails = async (userId) => {
    const response = await apiRequest(
      "Users",
      "GetUserSubscriptionBillingDetails",
      {}
    );
    if (response.status === "success") {
      updateState((draft) => {
        draft.userData.billingDetails = response.data;
      });
    } else {
      updateState((draft) => {
        draft.userData.billingDetails = null;
      });
    }
  };

  /**
   * set user data
   * @param {String} user - the users' email
   */
  const setUser = (user) => {
    if (user) {
      updateState((draft) => {
        draft.loggedIn = true;
        draft.userData = user.UserData;
      });
    } else {
      updateState((draft) => {
        draft.loggedIn = false;
        draft.userData = {};
      });
      removeLocalStorage("User");
    }
  };

  const setAuth = (auth, isRememberMe) => {
    if (auth?.data && !auth.status !== "error") {
      setAuthCookieInLocalStorage(auth, isRememberMe);
      return auth;
    } else {
      removeLocalStorage("Auth");
    }
  };

  const CreateOrUpdateUserProfileReact = async (image, fileName, fileId) => {
    const response = await apiRequest(
      "UserTemplates",
      `CreateOrUpdateUserProfileReact?&encryptedMailId=0&fileName=${fileName}&fileId=${fileId}`,
      image,
      "POST",
      null,
      null,
      null,
      true
    );

    if (response.status === "success") {
      updateState((draft) => {
        draft.userData.ProfileImageUrl = response.data.path;
      });
    } else {
      //logger("mailFactory", "ReactSetMainCoverForMail", response.data);
    }
    return response;
  };
  const deleteProfilePicture = async () => {
    const response = await apiRequest("Users", "DeleteProfilePicture");
    if (response.status === "success") {
      if (response.data === 0) {
        updateState((draft) => {
          draft.userData.ProfileImageUrl = null;
        });
      }
    } else {
    }
    return response;
  };

  const CreateOrUpdateContactProfileReact = async (
    image,
    fileName,
    fileId,
    userEmail
  ) => {
    const response = await apiRequest(
      "UserTemplates",
      `CreateOrUpdateContactProfileReact?fileName=${fileName}&fileId=${fileId}&userEmail=${userEmail}`,
      image,
      "POST",
      null,
      null,
      null,
      true
    );
    return response;
  };

  //Get jumboForms details:

  //Fetch forms list
  ///Get all embed Forms
  const fetchAllEmbedDynamicForms = async (listToFetch) => {
    //update state.jumboFormDetails.formList
    updateState((draft) => {
      draft.jumboFormDetails.formList = listToFetch;
    });
  };
  //Get all embed Forms
  const getEmbedDynamicForms = () => state.jumboFormDetails.formList;

  //fetch embedPage username and id
  const fetchEmbedPageByUserId = async () => {
    let embedPage = {};
    const response = await apiRequest(
      "EmbedDynamics",
      "GetEmbedDynamicPageByUserId"
    );
    if (response.status === "success") {
      embedPage.fetched = true;
      if (response.data && response.data.EmbedPageUserName) {
        embedPage.UserName = response.data.EmbedPageUserName;
        embedPage.PageId = response.data.EmbedPageId;
        embedPage.pageExist = true;
      } else {
        embedPage.UserName = null;
        embedPage.PageId = null;
        embedPage.pageExist = false;
      }
    } else {
      embedPage.fetched = true;
      embedPage.UserName = null;
      embedPage.PageId = null;
      embedPage.pageExist = false;
    }
  };

  //Get embedPage
  const getEmbedPage = () => state.jumboFormDetails.embedPage;

  const getUserBillingDetails = () => state.userData.billingDetails || {};

  const fetchContactList = async () => {
    const response = await ReactGetFavoriteContactListApiRequest();

    if (response.status === "success") {
      setContactList(response.data);
    } else {
      setContactList([]);
    }
  };

  const setContactList = (contactList) => {
    updateState((draft) => {
      draft.contactList = contactList;
    });
  };

  const getContactList = () => state.contactList;

  return {
    setUser,
    signup,
    login,
    logout,
    isLoggedIn,
    getUserProfileImage,
    isUserHasProfileImage,
    getUserByMail,
    getUserData,
    isBusiness,
    isPro,
    getIsIsrael,
    setIsIsrael,
    fetchIsraelUser,
    premiumExpired,
    isSubscribed,
    contactUs,
    authenticateAfterMvc,
    setUserData,
    setUserDataProp,
    setUserBillingDetailsDataProp,
    CreateOrUpdateUserProfileReact,
    deleteProfilePicture,
    isExpress,
    isPremium,
    fetchAllEmbedDynamicForms,
    getUserBillingDetails,
    fetchUserBillingDetails,
    getEmbedDynamicForms,
    getEmbedPage,
    fetchEmbedPageByUserId,
    CreateOrUpdateContactProfileReact,
    updateUserUsedStorage,
    getIsPendingLogin,
    isTokenExist,
    fetchContactList,
    getContactList,
    setContactList,
    setIsPendingLogin,
  };
}

export default userFactory;
